import * as React from "react";
import { Container } from "semantic-ui-react";

import { TaskModel } from "../task/taskActions/models";

const DATE_FORMAT = "LLLL";

interface Props {
    readonly: boolean;
    task: TaskModel | undefined;
}

export const CompletedDate: React.FunctionComponent<Props> = (props: Props) => {
    if (props.readonly && props.task?.completedDate) {
        return <Container><h4>{props.task.completedDate.format(DATE_FORMAT)}</h4></Container>;
    }
    return null;
};
